var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 294,
    viewBox: "0 0 206 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.895 277.5C66.6945 277.5 24.9945 230.4 17.7945 166.5C16.8945 160.2 16.5945 153.9 16.5945 147.3C16.5945 74.7 60.9945 16.8 115.895 16.8C144.695 16.8 171.695 32.7 192.395 64.2L205.895 55.2C182.195 20.1 149.795 0.89998 115.895 0.89998C52.5945 0.89998 0.694532 67.2 0.694532 147.3C0.694532 154.2 0.994532 161.4 1.89453 168.3C9.69453 239.1 59.4945 293.4 115.895 293.4C149.795 293.4 182.195 274.2 205.895 239.4L192.395 230.4C171.695 261.6 144.695 277.5 115.895 277.5Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperC);
export default __webpack_public_path__ + "static/media/UPPER_C.0b1d6ad85682f1a4e6f0ad0934081eae.svg";
export { ForwardRef as ReactComponent };